class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    const fill = this.querySelector('.cart-drawer__shipping-progress-fill');
    const wasActive = this.classList.contains('active');
    // Only replay from 0 on a cold open (user clicked the cart icon).
    // If renderContents just animated the bar, leave it alone.
    if (fill && !wasActive && !fill.dataset.animating) {
      const target = fill.getAttribute('data-target') || '0';
      fill.style.transition = 'none';
      fill.style.width = '0%';
      void fill.offsetWidth;
      requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = target + '%';
      });
    }
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  replayShippingProgress() {
    const fill = this.querySelector('.cart-drawer__shipping-progress-fill');
    if (!fill) return;
    fill.style.transform = 'scaleX(0)';
    fill.style.transition = 'none';
    void fill.offsetWidth;
    fill.style.transform = '';
    fill.style.transition = '';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    const inner = this.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    const items = this.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
    this.productId = parsedState.id;

    // Capture the previous progress-bar width so we can animate smoothly to the new one.
    const prevFill = this.querySelector('.cart-drawer__shipping-progress-fill');
    const prevWidth = prevFill ? prevFill.getAttribute('data-target') : null;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Animate the shipping progress from the old percent to the new percent.
    const newFill = this.querySelector('.cart-drawer__shipping-progress-fill');
    if (newFill) {
      const target = newFill.getAttribute('data-target') || '0';
      const start = prevWidth != null ? prevWidth : '0';
      newFill.dataset.animating = 'true';
      newFill.style.transition = 'none';
      newFill.style.width = start + '%';
      void newFill.offsetWidth;
      requestAnimationFrame(() => {
        newFill.style.transition = '';
        newFill.style.width = target + '%';
        setTimeout(() => {
          delete newFill.dataset.animating;
        }, 1000);
      });
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
